import { BureauRepayment, IBureauRepayment } from "../../clients/LoanClient";

export type RepaymentOverride = IBureauRepayment & {
  repayAmountOverride?: number | null;
  changeReason?: string | null;
}

export type ChangeReasonOption = {
  description: string;
  overrideAmountRequired: boolean;
  promptLabel?: string;
}

export const AffordabilityChallengeReasons: Record<string, ChangeReasonOption> = {
  PaymentArrangement: {
    description: 'I pay a portion of this',
    overrideAmountRequired: true,
    promptLabel: 'Enter portion you pay'
  },
  AccountSettled: {
    description: 'This account is settled',
    overrideAmountRequired: false
  },
  IncorrectInstalment: {
    description: 'This amount is incorrect',
    overrideAmountRequired: true,
    promptLabel: 'Enter instalment amount'

  },
};